import React from "react";
import Page from "@jumbo/shared/Page";
import UsersIndex from "app/pages/users/UsersIndex";
import CompanySettings from "app/pages/companies/CompanySettings";
import PluginsIndex from "app/pages/plugins/PluginsIndex";
import { Navigate } from "react-router-dom";
import DashboardsIndex from "app/pages/automations/dashboards/DashboardsIndex";
import DevicesIndex from "app/pages/automations/devices/DevicesIndex";
import StoresIndex from "app/pages/automations/stores/StoresIndex";
import StoreShow from "app/pages/automations/stores/StoreShow";
import AutomationsPage from "app/pages/automations/rules/AutomationsPage";
import DeviceAlertNotificationsIndex from "app/pages/automations/device_alerts/DeviceAlertNotificationsIndex";
import DownloadsIndex from "app/pages/automations/downloads/DownloadsIndex";
import ReportsIndex from "app/pages/automations/reports/ReportsIndex";
import SuperadminCompaniesIndex from "app/pages/superadmin/companies/CompaniesIndex";
import SuperadminDevicesIndex from "app/pages/superadmin/devices/DevicesIndex";
import SuperadminDemoRequestsIndex from "app/pages/superadmin/demo_requests/DemoRequestsIndex";
import SuperadminPluginsRootIndex from "app/pages/superadmin/plugins/CompanyPluginsRootIndex";
import SuperadminDeviceTypesIndex from "app/pages/superadmin/device_types/DeviceTypesIndex";
import SuperadminUsersIndex from "app/pages/superadmin/users/UsersIndex";
import SuperadminGatewaysIndex from "app/pages/superadmin/gateways/GatewaysIndex";
import SuperadminVisionDevicesIndex from "app/pages/superadmin/vision/VisionDevicesIndex";
import SuperadminVisionDeviceShow from "app/pages/superadmin/vision/VisionDeviceShow";
import MyProfile from "app/pages/account/MyProfile";

const mainRoutes = [
    {
        path: "/",
        element: <Page component={StoresIndex} />
    },
    {
        path: "/automations/dashboards",
        element: <Page component={DashboardsIndex} />
    },
    {
        path: "/automations/dashboards/summary",
        element: <Navigate to="/automations/dashboards" replace />
    },
    {
        path: "/automations/stores",
        element: <Page component={StoresIndex} />
    },
    {
        path: "/automations/stores/:id",
        element: <Page component={StoreShow} />
    },
    {
        path: "/automations/devices",
        element: <Page component={DevicesIndex} />
    },
    {
        // Lista y editores de todos los tipos de automatización, con sus rutas anidadas (ver AutomationsPage).
        path: "/automations/rules/*",
        element: <Page component={AutomationsPage} />
    },
    {
        path: "/automations/notifications",
        element: <Page component={DeviceAlertNotificationsIndex} />
    },
    {
        path: "/automations/reports/*",
        element: <Page component={ReportsIndex} />
    },
    {
        path: "/automations/downloads",
        element: <Page component={DownloadsIndex} />
    },
    {
        path: "/company_settings",
        element: <Page component={CompanySettings} />
    },
    {
        path: "/plugins",
        element: <Page component={PluginsIndex} />
    },
    {
        path: "/users",
        element: <Page component={UsersIndex} />
    },
    {
        path: "/profile",
        element: <Page component={MyProfile} />
    },
    {
        path: "/superadmin/companies",
        element: <Page component={SuperadminCompaniesIndex} />
    },
    {
        path: "/superadmin/devices",
        element: <Page component={SuperadminDevicesIndex} />
    },
    {
        path: "/superadmin/demo-requests",
        element: <Page component={SuperadminDemoRequestsIndex} />
    },
    {
        path: "/superadmin/users",
        element: <Page component={SuperadminUsersIndex} />
    },
    {
        path: "/superadmin/plugins",
        element: <Page component={SuperadminPluginsRootIndex} />
    },
    {
        path: "/superadmin/device-types",
        element: <Page component={SuperadminDeviceTypesIndex} />
    },
    {
        path: "/superadmin/gateways",
        element: <Page component={SuperadminGatewaysIndex} />
    },
    {
        path: "/superadmin/vision",
        element: <Page component={SuperadminVisionDevicesIndex} />
    },
    {
        path: "/superadmin/vision/:id",
        element: <Page component={SuperadminVisionDeviceShow} />
    },
];

export default mainRoutes;
